import { useTextePublic } from '../lib/textes-publics'
/**
 * Indicateur d’attente. Muet pour les lecteurs d’écran par défaut : c’est au
 * conteneur (`aria-busy`, `role="status"`) de dire *ce* qui charge.
 */

import { cn } from '../lib/cn'

export type TailleSpinner = 'sm' | 'md' | 'lg'

const TAILLES: Readonly<Record<TailleSpinner, string>> = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-10 border-[3px]',
}

export interface SpinnerProps {
  readonly taille?: TailleSpinner | undefined
  /** Annoncé aux lecteurs d’écran ; sans libellé, le spinner est décoratif. */
  readonly libelle?: string | undefined
  readonly className?: string | undefined
}

export function Spinner({ taille = 'md', libelle, className }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent align-[-0.125em]',
        TAILLES[taille],
        className,
      )}
      role={libelle === undefined ? undefined : 'status'}
      aria-hidden={libelle === undefined ? true : undefined}
      aria-label={libelle}
    />
  )
}

/** Attente pleine page (chargement d’une route, vérification de session). */
export function ChargementPage({ libelle }: { readonly libelle?: string | undefined }) {
  const texteInterface = useTextePublic()
  return (
    <output
      className="flex min-h-64 flex-col items-center justify-center gap-3 p-12 text-slate-500"

      aria-live="polite"
    >
      <Spinner taille="lg" />
      <p className="text-sm">{libelle ?? texteInterface('Chargement…')}</p>
    </output>
  )
}
